<div class="card_offer card_creator" [ngClass]="cardClasses">
    <div class="row h_full direction_y">
        <div class="col_content card_top">
            <div class="visuel">
                <img [src]="item.logo ? ( item.logo | fileSource | async) : defaultVisualUrl" [alt]="item.name">
                <div class="infos">
                    <div class="upper_left">
                        @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION']) && (item.details.totalCatalogOffers > 0)) {
                            <span class="has-offer-in-catalog"><span>{{ 'offerCreator.inCatalog.mine.value' | translate }}</span></span>
                        }
                    </div>
                    <div class="tags right">
                        <div class="tag premium">
                            @if(isPremium) {
                                <img src="assets/images/subscription-premium.svg" alt="{{ 'offerCreator.premium.value' | translate }}" matTooltip="{{ 'offerCreator.premium.value' | translate }}" />
                            }
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col card_bottom">
            <div class="infos_offer">
                <div class="row h_full direction_y">
                    <div class="col infos_wrapper">
                        <div class="infos" [ngClass]="{'closed' : cardClosed}">
                            <div class="row marges">
                                <div class="col y_items_center title">
                                    <div class="row">
                                        <div class="col_12">
                                            <p>{{ item.name }}</p>
                                        </div>
                                    </div>
                                </div>
                                <div class="col_content y_items_start">
                                    <span class="show_more ty-chevron" (click)="cardClosed ? cardClosed = false : cardClosed = true"></span>
                                </div>
                            </div>

                            @if(item.details.totalMarketplaceOffers > 0) {

                                <div class="row marges">
                                    <div class="col_12">
                                        <p style="font-weight: 500;">

                                            @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_SUPER_ADMIN', 'ROLE_ADMIN'])) {
                                                {{ item.details.totalMarketplaceOffers | translationFromQuantity:'offer.inMarketplace.total.empty.value':'offer.inMarketplace.total.singular.value':'offer.inMarketplace.total.plural.value' }}
                                            }
                                            @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_OFFER_DISTRIBUTOR', 'ROLE_FEDERATION', 'ROLE_INSTITUTIONAL'])) {
                                                {{ item.details.totalMarketplaceOffers | translationFromQuantity:'offer.inMarketplace.self.total.empty.value' : 'offer.inMarketplace.self.total.singular.value' : 'offer.inMarketplace.self.total.plural.value' }}
                                            }

                                        </p>
                                    </div>
                                </div>

                                @if(userService.hasOneOfThisRoles(currentUser, ['ROLE_OFFER_DISTRIBUTOR', 'ROLE_INSTITUTIONAL', 'ROLE_FEDERATION'])) {

                                    <div class="row marges">
                                        <div class="col_12">
                                            <p style="font-weight: 500;">
                                                {{ item.details.totalCatalogOffers | translationFromQuantity: 'offer.inCatalog.total.empty.value' : 'offer.inCatalog.total.singular.value' : 'offer.inCatalog.total.plural.value' }}
                                            </p>
                                        </div>
                                    </div>
                                }
                            }

                            <div class="infos_sup">

                                @if(item.details.customerTypologies.length > 0) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{ 'target.plural.value' | translate }}</p>
                                        </div>
                                        <div class="col_7">
                                            <p>{{ parsedTargets }}</p>
                                        </div>
                                    </div>
                                }

                                @if(item.details.allRegions || (item.details.regions.length > 0)) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{ 'destination.plural.value' | translate }}</p>
                                        </div>
                                        <div class="col_7">
                                            @if(item.details.allRegions) {
                                                <p>{{ 'france.all.value' | translate }}</p>
                                            } @else {
                                                <p>{{ parsedRegions }}</p>
                                            }
                                        </div>
                                    </div>
                                }

                                @if(item.details.durationTypes.length > 0) {

                                    <div class="row">
                                        <div class="col_5">
                                            <p>{{ 'offer.plural.type.plural.value' | translate }}</p>
                                        </div>
                                        <div class="col_7">
                                            <p>{{ parsedOfferTypes }}</p>
                                        </div>
                                    </div>
                                }

                            </div>
                        </div>
                    </div>
                    <div class="col_content">
                        <div class="links_offer">

                            <!-- Actions customisées -->

                            @for(customAction of offerCreatorCardService.customActions; track customAction) {

                                <div [ngClass]="customAction.containerClassesCallback(item)">
                                    <a [ngClass]="customAction.buttonClassesCallback(item)" [matTooltip]="customAction.buttonTooltipCallback(item)" matTooltipPosition="above" [matTooltipDisabled]="!customAction.buttonTooltipDisplayedCallback(item)" (click)="customAction.clickCallback(item)">
                                        <span>{{ customAction.labelCallback(item) }}</span>
                                    </a>
                                </div>
                            }

                            <!-- Offres du créateur d'offre -->

                            @if(offersListMode) {

                                <div class="btn_degrade">
                                    <a [routerLink]="['/account/offer/list', offersListMode]" target="_blank" [queryParams]="offersQueryParams">
                                        <span>{{ 'offerCreator.offer.plural.see.action.value' | translate }}</span>
                                    </a>
                                </div>
                            }

                            <!-- Détails du créateur d'offre -->

                            <div>
                                <a [routerLink]="['/account/offer-creator/read', item.id]" [target]="isOneOfTheseModes(['quotation', 'tender']) ? '_blank' : '_self'" [queryParams]="{ 'list-redirection-allowed': isOneOfTheseModes(['quotation', 'tender']) ? 0 : 1 }">
                                    <span>{{ 'profile.see.action.value' | translate }}</span>
                                </a>
                            </div>

                            <!-- Sélection -->

                            @if(offerCreatorSearchService.selectOfferCreatorEnabled) {

                                @if(offerCreatorSearchService.isSelectedOfferCreator(item)) {

                                    <div class="creator_selection">
                                        <a [ngClass]="{'disabled' : !offerCreatorSearchService.unselectOfferCreatorAllowed || !offerCreatorSearchService.isOfferCreatorUnselectionAllowed(item)}" [matTooltip]="offerCreatorSearchService.offerCreatorUnselectionDisableReason(item)" matTooltipPosition="above" [matTooltipDisabled]="offerCreatorSearchService.unselectOfferCreatorAllowed && offerCreatorSearchService.isOfferCreatorUnselectionAllowed(item)" (click)="offerCreatorSearchService.unselectOfferCreator(item)" class="creator_selected">
                                            <span>{{'offerCreator.selected' | translate}}</span>
                                        </a>
                                    </div>

                                } @else {

                                    <div class="creator_selection">
                                        <a [ngClass]="{'disabled' : !offerCreatorSearchService.selectOfferCreatorAllowed || !offerCreatorSearchService.isOfferCreatorSelectionAllowed(item)}" [matTooltip]="offerCreatorSearchService.offerCreatorSelectionDisableReason(item)" matTooltipPosition="above" [matTooltipDisabled]="offerCreatorSearchService.selectOfferCreatorAllowed && offerCreatorSearchService.isOfferCreatorSelectionAllowed(item)" (click)="offerCreatorSearchService.selectOfferCreator(item)">
                                            <span>{{ 'offerCreator.selection.action.value' | translate }}</span>
                                        </a>
                                    </div>
                                }
                            }

                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
